<template>
  <div class="home-mast">

    <div class="images">
      <div class="image">
        <Image
          :src="$IMG(`assets/images/home_mast.png`)" 
          :srcset="`
            ${$IMG('assets/images/home_mast_sm.png')} 600w,
            ${$IMG('assets/images/home_mast_md.png')} 768w
          `"
          alt=""
        />
      </div>
    </div>

    <div class="container">
      <div class="text">
        <h1 class="mast-title">
          OGQ GYN<br>
          Deep Manager
        </h1>
        <p class="mast-copy">
          OGQ GYN의 AI 기술 솔루션<br>
          딥매니저를 직접 체험해 보세요.
        </p>
        <p class="mast-copy-sub">
          딥매니저는 OGQ GYN의 딥러닝 기반의 이미지 인식<br>
          기술을 활용한 AI 솔루션 입니다.
        </p>
      </div>
    </div>

  </div>
</template>

<script>
// import Button from '@/components/el/Button'

export default {
  components: {
    // Button
  }
}
</script>

<style lang="scss" scoped>
.home-mast {
  position: relative;
  width: 100%;
  height: 500px;
  @media screen and (max-width: 600px) {
    height: auto;
  }
  // background-color: red;
}

.container {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 1200px;
  height: inherit;
  padding: 0 20px;
  margin: 0 auto;
  z-index: 2;
  @media screen and (max-width: 1140px) {
    align-items: flex-end;
    padding: 0;
  }
}

.text {
  @media screen and (max-width: 1140px) {
    background-color: var(--primary-500);
    color: #FFF;
    padding: 28px 44px 28px 24px;
  }
  @media screen and (max-width: 600px) {
    padding: 20px 16px;
    width: 100%;
  }
}

h1.mast-title {
  font-size: 64px;
  line-height: 74px;
  margin: 0 0 30px;
  line-height: 1;
  color: var(--primary-500);
  @media screen and (max-width: 1140px) {
    color: #FFF;
    font-size: 50px;
    margin: 0 0 10px;
  }
  @media screen and (max-width: 600px) {
    font-size: 32px;
    margin: 0 0 16px;
  }
}
p.mast-copy {
  font-size: var(--typ-body1);
  color: var(--gray-800);
  margin: 0 0 16px;
  font-weight: 700;
  @media screen and (max-width: 1140px) {
    color: #FFF;
    font-size: var(--typ-body3);
    font-weight: 400;
    margin: 0;
  }
  @media screen and (max-width: 600px) {

  }
}
p.mast-copy-sub {
  font-size: var(--typ-body3);
  color: var(--gray-700);
  margin: 0 0;
  font-weight: 400;
  @media screen and (max-width: 1140px) {
    color: #FFF;
    display: none;
  }
}

.images {
  z-index: 1;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  @media screen and (max-width: 1140px) {

  }
  @media screen and (max-width: 600px) {
    position: relative;
  }
}
.images .image {
  position: absolute;
  top: 0;
  right: 50%;
  height: 100%;
  transform: translate3d(100%, 0, 0);
  @media screen and (max-width: 1140px) {
    transform: none;
    right: 0;
    left: 0;
  }
  @media screen and (max-width: 600px) {
    position: relative;
  }
}
.images .image img {
  display: block;
  width: auto;
  height: 100%;
  @media screen and (max-width: 1140px) {
    width: 100%;
    object-fit: cover;
    object-position: center center;
  }
  @media screen and (max-width: 600px) {
    width: 100%;
    height: auto;
    object-fit: auto;
  }
}
</style>